import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { configureSuccess, configureError } from './actions';
import { CONFIGURE_PENDING } from './constants';

export function* fetchConfig(): Generator {
  try {
    const response: any = yield call([axios, axios.get], '/config/config.json');

    yield put(configureSuccess(response.data));
  } catch (error) {
    yield put(configureError(error as Error));
  }
}

export function* configSaga(): Generator {
  yield takeLatest(CONFIGURE_PENDING, fetchConfig);
}
